import React from 'react';
import * as Yup from 'yup';
import { Button } from '@economic/taco';
import { t, Trans } from '@lingui/macro';
import { Field, Form } from '../../shared/components/Form';
import { useMutation } from '../../shared/components/Mutation';
import { OnboardingStatusCompanyData } from './types';

const bankValidationScheme = () =>
    Yup.object().shape({
        name: Yup.string().required(),
        number: Yup.string().required(),
        account: Yup.string().required(),
    });

interface Props {
    company: OnboardingStatusCompanyData;
    onDone: () => void;
    onBack: () => void;
    onSkip: () => void;
    children: string | JSX.Element;
}

export default function StepBankInfo({ company, onBack, onDone, onSkip, children }: Props) {
    const updateCompanyBankData = useMutation(`/onboarding/bank-data`, 'PUT');
    function saveBankInfo(values: any) {
        updateCompanyBankData(values);
        onDone();
    }

    const initialData = {
        name: company.bankName,
        number: company.bankRegistrationNumber,
        account: company.bankAccount,
        swift: company.bankSwift,
        iban: company.bankIban,
    };

    return (
        <div className="onboarding__container__fixed-size">
            <div className="onboarding onboarding__bank-info">
                {children}

                <h2>
                    <Trans>Add bank information</Trans>
                </h2>

                <p className="text-center">
                    <Trans>
                        Adding a bank information will make sure that the customers can pay your invoices. If you’re not ready for
                        this step, you can add the information later
                    </Trans>
                </p>
                <Form skipNotifications onSubmit={saveBankInfo} validationSchema={bankValidationScheme} initialData={initialData}>
                    <div className="onboarding__form-content">
                        <Field.Text name="name" label={t`Bank name`} maxLength={100} required />

                        <div className="columns">
                            <Field.Text name="number" label={t`Reg. number`} maxLength={50} required />
                            <Field.Text name="account" label={t`Account number`} maxLength={50} required />
                        </div>
                        <div className="columns">
                            <Field.Text name="swift" label={t`SWIFT code`} maxLength={20} />
                            <Field.Text name="iban" label={t`IBAN number`} maxLength={50} />
                        </div>
                    </div>
                    <div className="columns">
                        <div className="onboarding__navigation-buttons">
                            <div className="onboarding__skip-step">
                                <Button
                                    appearance="discrete"
                                    onClick={e => {
                                        e.preventDefault();
                                        onSkip();
                                    }}>
                                    <Trans>Skip this step</Trans>
                                </Button>
                            </div>

                            <Button appearance="primary" type="submit">
                                <Trans>Next</Trans>
                            </Button>

                            <Button
                                appearance="discrete"
                                onClick={e => {
                                    e.preventDefault();
                                    onBack();
                                }}>
                                <Trans>Back</Trans>
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
}
